import { SearchGroupNames, SearchResponseKeys } from '../../enums/common';

export const searchGroupMap = {
  [SearchResponseKeys.PARENTS_GUARDIANS]: SearchGroupNames.PARENTS_GUARDIANS,
  [SearchResponseKeys.USER_PROFILES]: SearchGroupNames.USER_PROFILES,
  [SearchResponseKeys.EVENTS]: SearchGroupNames.EVENTS,
  [SearchResponseKeys.ROLES]: SearchGroupNames.ROLES,
  [SearchResponseKeys.YOUTH_CLUB_MEMBERS]: SearchGroupNames.YOUTH_CLUB_MEMBERS,
};
